import { useSafeApiOrgSlug } from '../../../utils/orgSlug'
import { useApiQuery } from '../../../utils/reactQuery'

const AnnouncementsStaleTime = 30 * 60 * 1000
const AnnouncementsGcTime = 7 * 24 * 60 * 60 * 1000

export function useAnnouncementsQuery() {
  const orgSlug = useSafeApiOrgSlug()
  const accountAnnouncementsQuery = useApiQuery(
    'get',
    '/{org_slug}/announcements',
    {
      params: {
        path: {
          org_slug: orgSlug ?? '',
        },
      },
    },
    {
      enabled: orgSlug !== null,
      gcTime: AnnouncementsGcTime,
      staleTime: AnnouncementsStaleTime,
    },
  )
  const globalAnnouncementsQuery = useApiQuery(
    'get',
    '/announcements',
    {},
    {
      enabled: orgSlug === null,
      gcTime: AnnouncementsGcTime,
      staleTime: AnnouncementsStaleTime,
    },
  )

  return orgSlug === null ? globalAnnouncementsQuery : accountAnnouncementsQuery
}
